import styles from "./demo.module.css";

export default function DemoDashboard() {
  return (
    <div className={styles.page}>
      {/* Top bar */}
      <header className={styles.topbar}>
        <div className={styles.brand}>luci</div>

        <div className={styles.topbarRight}>
          <button className={styles.linkBtn} type="button">Refresh</button>
          <button className={styles.primaryBtn} type="button">Export Data</button>

          <div className={styles.userPill}>
            <span className={styles.userName}>Demo User</span>
            <span className={styles.userAvatar}>DU</span>
          </div>
        </div>
      </header>

      <main className={styles.container}>
        {/* Filter row */}
        <div className={styles.controlsRow}>
          <div />
          <div className={styles.filterWrap}>
            <button className={styles.filterBtn} type="button">
              Filter by Zip Code <span className={styles.caret}>▾</span>
            </button>
          </div>
        </div>

        {/* KPI cards */}
        <section className={styles.kpiGrid}>
          <div className={styles.card}>
            <div className={styles.cardTitle}>Total Users</div>
            <div className={styles.kpiValue}>100</div>
          </div>

          <div className={styles.card}>
            <div className={styles.cardTitle}>Number of Days Active</div>
            <div className={styles.kpiValue}>2.2K</div>
            <div className={styles.kpiSub}>Avg: 22 per User</div>
          </div>

          <div className={styles.card}>
            <div className={styles.cardTitle}>Total Number of Lessons Completed</div>
            <div className={styles.kpiValue}>3.2K</div>
            <div className={styles.kpiSub}>Avg: 32 per User</div>
          </div>
        </section>

        {/* Bottom charts */}
        <section className={styles.bottomGrid}>
          {/* Donut / Users by Zip */}
          <div className={styles.card}>
            <div className={styles.cardTitle}>Users by Zip Code</div>

            <div className={styles.zipLayout}>
              <div className={styles.donutWrap}>
                <div
                  className={styles.donut}
                  aria-label="Users by Zip Code donut chart"
                >
                  <div className={styles.donutHole}>
                    <div className={styles.donutCenterTitle}>Top Zip Codes</div>
                    <div className={styles.donutCenterList}>
                      <div><strong>77338</strong> - 50 (50%)</div>
                      <div><strong>77027</strong> - 30 (30%)</div>
                      <div><strong>76102</strong> - 20 (20%)</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.legend}>
                <div className={styles.legendItem}>
                  <span className={`${styles.swatch} ${styles.swatchOrange}`} />
                  <span>77338 - 50 (50%)</span>
                </div>
                <div className={styles.legendItem}>
                  <span className={`${styles.swatch} ${styles.swatchBlue}`} />
                  <span>77027 - 30 (30%)</span>
                </div>
                <div className={styles.legendItem}>
                  <span className={`${styles.swatch} ${styles.swatchGray}`} />
                  <span>76102 - 20 (20%)</span>
                </div>
              </div>
            </div>
          </div>

          {/* Bar chart / In-App interactions */}
          <div className={styles.card}>
            <div className={styles.cardTitle}>In-App Interactions</div>

            <div className={styles.winRateRow}>
              <div className={styles.winRateLabel}>
                Win Rate: <strong>70%</strong>
              </div>
            </div>

            <div className={styles.barArea}>
              <div className={styles.barGroup}>
                <div className={styles.barTopValue}>1,640</div>
                <div
                  className={`${styles.bar} ${styles.barBlue}`}
                  style={{ "--h": 220 }}
                />
                <div className={styles.barLabel}>Games Played</div>
              </div>

              <div className={styles.barGroup}>
                <div className={styles.barTopValue}>1,148</div>
                <div
                  className={`${styles.bar} ${styles.barOrange}`}
                  style={{ "--h": 155 }}
                />
                <div className={styles.barLabel}>Games Won</div>
              </div>
            </div>
          </div>        
        </section>
      </main>
    </div>
  );
}
